const COMMON = {
  AEH_LOGIN: 'login/aeh'
};

const PNQ = {
  CREATE_LEAD: 'aehLead/createLead',
  GET_LEAD: 'lead/get',
  VALIDATE_LEAD: 'aehLead/fetchLead',
  GET_LSI_DETAILS: 'aehLead/fetch/lsiDetails',
  GET_PRICING: 'pricing',
  GET_CPE: 'CPE',
  GET_NON_STANDARD_CPE: 'config/client/fetch',
  CHECK_FEASIBILITY: 'feasibility/check',
  CHECK_FOR_ID: 'feasibility/checkForId',
  UPDATE_LEAD: 'aehLead/update',
  CANCEL_LEAD: 'aehLead/cancelLead',
  NEED_ASSISTANCE: 'aehLead/needAssistance',
  SUBMIT_LEAD: 'aehLead/submitLead',
  LEAD_TAGS: 'lead/tags/get',
  KAM_SUBMIT_LEAD: 'lead/submit',
  DOA_SUBMIT_CLARITY: 'lead/doaSubmitClarity',
  DOA_LIFE_CYCLE: 'lead/doaGetLifeCycle'
};

const KYC = {
  CREATE_ORDER: 'order/create',
  FETCH_ORDER: 'order/fetch',
  UPLOAD_DOC: 'order/documents/upload',
  DELETE_DOC: 'order/documents/delete',
  GET_DOC: 'order/documents/fetch',
  DOWNLOAD_DOC: 'document/download?documentUrl=',
  UPDATE_ORDER: 'order/update',
  SEND_OTP: 'otp/send',
  VERIFY_OTP: 'otp/verify',
  CANCEL_ORDER: 'order/cancel',
  SUBMIT_ORDER: 'order/submit'
};

const API_ERROR = {
  DEFAULT_MSG: 'Something went wrong. Please try again...'
};

export { COMMON, PNQ, KYC, API_ERROR };
